module.exports = __webpack_public_path__ + "img/bg1.a8bcee41.gif";